import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from "react-router";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAuthenticatedFrame } from "./authenticated-frame.selector";
import { Authenticated } from "@/v2/application/authenticated";
import { initializeLocalState } from "./authenticated-frame.local-state";
export default function AuthenticatedFrameResolver() {
    // Get initial loaded state for feature from global store
    const loadedState = useSelector(getAuthenticatedFrame);
    const [localState, localDispatch] = initializeLocalState({ showMyProfile: false });
    const globalDispatch = useDispatch();
    // Dispatch loading actions to retrieve initial feature state from api endpoints
    useEffect(() => {
        globalDispatch(Authenticated.Actions.fetchAuthenticated());
    }, []);
    useEffect(() => {
        if (!loadedState.isLoggedIn)
            window.location.href = '/guest-login'; // TODO: add
    }, [loadedState.isLoggedIn]);
    // Add states and dispatch fncs to feature components via router outlet
    return (_jsx(Outlet, { context: { loadedState, globalDispatch, localState, localDispatch } }));
}
